import React, {useRef, useEffect} from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import SuccessImg from '../../../../assets/images/success-icon.png'

const SuccessMessage = ({ 
  showModal, 
  closeModal, 
  getLangTranslation, 
  message,
  value
}) => {
    const modalRef = useRef();
  
    useEffect(() => {
      if (showModal) {
          const modal = new Modal(modalRef.current, {
              backdrop: 'static',
              keyboard: false,
            });
          modal.show();
      }
    }, [showModal]);
    
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
         <div className="modal-dialog modal-dialog-centered modal-sm">
             <div className="modal-content">
                <div className="modal-body">
                        <img src={SuccessImg} className="mx-auto d-block mb-6" alt="..." />
                    <h5 className='fw-bold mb-9 text-center'>{getLangTranslation(message, value)}</h5>
                    <button className="btn btn-primary w-100" type="button" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}>
                        <span className="btn-upper-case">{getLangTranslation('DEFAULT_SETTING_GOT_IT', 'Got it')}</span>
                    </button>
                </div>
             </div>
         </div>
     </div>
  )
}

export default SuccessMessage